"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateStateMachineAliasOutput$ = exports.CreateStateMachineAliasInput$ = exports.CreateActivityOutput$ = exports.CreateActivityInput$ = exports.CloudWatchLogsLogGroup$ = exports.CloudWatchEventsExecutionDataDetails$ = exports.BillingDetails$ = exports.AssignedVariablesDetails$ = exports.ActivityTimedOutEventDetails$ = exports.ActivitySucceededEventDetails$ = exports.ActivityStartedEventDetails$ = exports.ActivityScheduleFailedEventDetails$ = exports.ActivityScheduledEventDetails$ = exports.ActivityListItem$ = exports.ActivityFailedEventDetails$ = exports.errorTypeRegistries = exports.ValidationException$ = exports.TooManyTags$ = exports.TaskTimedOut$ = exports.TaskDoesNotExist$ = exports.StateMachineTypeNotSupported$ = exports.StateMachineLimitExceeded$ = exports.StateMachineDoesNotExist$ = exports.StateMachineDeleting$ = exports.StateMachineAlreadyExists$ = exports.ServiceQuotaExceededException$ = exports.ResourceNotFound$ = exports.MissingRequiredParameter$ = exports.KmsThrottlingException$ = exports.KmsInvalidStateException$ = exports.KmsAccessDeniedException$ = exports.InvalidTracingConfiguration$ = exports.InvalidToken$ = exports.InvalidOutput$ = exports.InvalidName$ = exports.InvalidLoggingConfiguration$ = exports.InvalidExecutionInput$ = exports.InvalidEncryptionConfiguration$ = exports.InvalidDefinition$ = exports.InvalidArn$ = exports.ExecutionNotRedrivable$ = exports.ExecutionLimitExceeded$ = exports.ExecutionDoesNotExist$ = exports.ExecutionAlreadyExists$ = exports.ConflictException$ = exports.ActivityWorkerLimitExceeded$ = exports.ActivityLimitExceeded$ = exports.ActivityDoesNotExist$ = exports.ActivityAlreadyExists$ = exports.SFNServiceException$ = void 0;
exports.ListExecutionsInput$ = exports.ListActivitiesOutput$ = exports.ListActivitiesInput$ = exports.LambdaFunctionTimedOutEventDetails$ = exports.LambdaFunctionSucceededEventDetails$ = exports.LambdaFunctionStartFailedEventDetails$ = exports.LambdaFunctionScheduleFailedEventDetails$ = exports.LambdaFunctionScheduledEventDetails$ = exports.LambdaFunctionFailedEventDetails$ = exports.InspectionErrorDetails$ = exports.InspectionDataResponse$ = exports.InspectionDataRequest$ = exports.InspectionData$ = exports.HistoryEventExecutionDataDetails$ = exports.HistoryEvent$ = exports.GetExecutionHistoryOutput$ = exports.GetExecutionHistoryInput$ = exports.GetActivityTaskOutput$ = exports.GetActivityTaskInput$ = exports.ExecutionTimedOutEventDetails$ = exports.ExecutionSucceededEventDetails$ = exports.ExecutionStartedEventDetails$ = exports.ExecutionRedrivenEventDetails$ = exports.ExecutionListItem$ = exports.ExecutionFailedEventDetails$ = exports.ExecutionAbortedEventDetails$ = exports.EvaluationFailedEventDetails$ = exports.EncryptionConfiguration$ = exports.DescribeStateMachineOutput$ = exports.DescribeStateMachineInput$ = exports.DescribeStateMachineForExecutionOutput$ = exports.DescribeStateMachineForExecutionInput$ = exports.DescribeStateMachineAliasOutput$ = exports.DescribeStateMachineAliasInput$ = exports.DescribeMapRunOutput$ = exports.DescribeMapRunInput$ = exports.DescribeExecutionOutput$ = exports.DescribeExecutionInput$ = exports.DescribeActivityOutput$ = exports.DescribeActivityInput$ = exports.DeleteStateMachineVersionOutput$ = exports.DeleteStateMachineVersionInput$ = exports.DeleteStateMachineOutput$ = exports.DeleteStateMachineInput$ = exports.DeleteStateMachineAliasOutput$ = exports.DeleteStateMachineAliasInput$ = exports.DeleteActivityOutput$ = exports.DeleteActivityInput$ = exports.CreateStateMachineOutput$ = exports.CreateStateMachineInput$ = void 0;
exports.TaskFailedEventDetails$ = exports.TaskCredentials$ = exports.TagResourceOutput$ = exports.TagResourceInput$ = exports.Tag$ = exports.StopExecutionOutput$ = exports.StopExecutionInput$ = exports.StateMachineVersionListItem$ = exports.StateMachineListItem$ = exports.StateMachineAliasListItem$ = exports.StateExitedEventDetails$ = exports.StateEnteredEventDetails$ = exports.StartSyncExecutionOutput$ = exports.StartSyncExecutionInput$ = exports.StartExecutionOutput$ = exports.StartExecutionInput$ = exports.SendTaskSuccessOutput$ = exports.SendTaskSuccessInput$ = exports.SendTaskHeartbeatOutput$ = exports.SendTaskHeartbeatInput$ = exports.SendTaskFailureOutput$ = exports.SendTaskFailureInput$ = exports.RoutingConfigurationListItem$ = exports.RedriveExecutionOutput$ = exports.RedriveExecutionInput$ = exports.PublishStateMachineVersionOutput$ = exports.PublishStateMachineVersionInput$ = exports.MockInput$ = exports.MockErrorOutput$ = exports.MapStateStartedEventDetails$ = exports.MapRunStartedEventDetails$ = exports.MapRunRedrivenEventDetails$ = exports.MapRunListItem$ = exports.MapRunItemCounts$ = exports.MapRunFailedEventDetails$ = exports.MapRunExecutionCounts$ = exports.MapIterationEventDetails$ = exports.LoggingConfiguration$ = exports.LogDestination$ = exports.ListTagsForResourceOutput$ = exports.ListTagsForResourceInput$ = exports.ListStateMachineVersionsOutput$ = exports.ListStateMachineVersionsInput$ = exports.ListStateMachinesOutput$ = exports.ListStateMachinesInput$ = exports.ListStateMachineAliasesOutput$ = exports.ListStateMachineAliasesInput$ = exports.ListMapRunsOutput$ = exports.ListMapRunsInput$ = exports.ListExecutionsOutput$ = void 0;
exports.StartExecution$ = exports.SendTaskSuccess$ = exports.SendTaskHeartbeat$ = exports.SendTaskFailure$ = exports.RedriveExecution$ = exports.PublishStateMachineVersion$ = exports.ListTagsForResource$ = exports.ListStateMachineVersions$ = exports.ListStateMachines$ = exports.ListStateMachineAliases$ = exports.ListMapRuns$ = exports.ListExecutions$ = exports.ListActivities$ = exports.GetExecutionHistory$ = exports.GetActivityTask$ = exports.DescribeStateMachineForExecution$ = exports.DescribeStateMachineAlias$ = exports.DescribeStateMachine$ = exports.DescribeMapRun$ = exports.DescribeExecution$ = exports.DescribeActivity$ = exports.DeleteStateMachineVersion$ = exports.DeleteStateMachineAlias$ = exports.DeleteStateMachine$ = exports.DeleteActivity$ = exports.CreateStateMachineAlias$ = exports.CreateStateMachine$ = exports.CreateActivity$ = exports.ValidateStateMachineDefinitionOutput$ = exports.ValidateStateMachineDefinitionInput$ = exports.ValidateStateMachineDefinitionDiagnostic$ = exports.UpdateStateMachineOutput$ = exports.UpdateStateMachineInput$ = exports.UpdateStateMachineAliasOutput$ = exports.UpdateStateMachineAliasInput$ = exports.UpdateMapRunOutput$ = exports.UpdateMapRunInput$ = exports.UntagResourceOutput$ = exports.UntagResourceInput$ = exports.TracingConfiguration$ = exports.TestStateOutput$ = exports.TestStateInput$ = exports.TestStateConfiguration$ = exports.TaskTimedOutEventDetails$ = exports.TaskSucceededEventDetails$ = exports.TaskSubmittedEventDetails$ = exports.TaskSubmitFailedEventDetails$ = exports.TaskStartFailedEventDetails$ = exports.TaskStartedEventDetails$ = exports.TaskScheduledEventDetails$ = void 0;
exports.ValidateStateMachineDefinition$ = exports.UpdateStateMachineAlias$ = exports.UpdateStateMachine$ = exports.UpdateMapRun$ = exports.UntagResource$ = exports.TestState$ = exports.TagResource$ = exports.StopExecution$ = exports.StartSyncExecution$ = void 0;
const _AAE = "ActivityAlreadyExists";
const _AD = "AliasDescription";
const _ADNE = "ActivityDoesNotExist";
const _AFED = "ActivityFailedEventDetails";
const _AL = "ActivityList";
const _ALE = "ActivityLimitExceeded";
const _ALI = "ActivityListItem";
const _ASED = "ActivityScheduledEventDetails";
const _ASEDc = "ActivityStartedEventDetails";
const _ASEDct = "ActivitySucceededEventDetails";
const _ASFED = "ActivityScheduleFailedEventDetails";
const _ATOED = "ActivityTimedOutEventDetails";
const _AV = "AssignedVariables";
const _AVD = "AssignedVariablesDetails";
const _AWLE = "ActivityWorkerLimitExceeded";
const _BD = "BillingDetails";
const _CA = "CreateActivity";
const _CAI = "CreateActivityInput";
const _CAO = "CreateActivityOutput";
const _CE = "ConflictException";
const _CP = "ConnectorParameters";
const _CSM = "CreateStateMachine";
const _CSMA = "CreateStateMachineAlias";
const _CSMAI = "CreateStateMachineAliasInput";
const _CSMAO = "CreateStateMachineAliasOutput";
const _CSMI = "CreateStateMachineInput";
const _CSMO = "CreateStateMachineOutput";
const _CWEEDD = "CloudWatchEventsExecutionDataDetails";
const _CWLLG = "CloudWatchLogsLogGroup";
const _D = "Definition";
const _DA = "DeleteActivity";
const _DAI = "DeleteActivityInput";
const _DAIe = "DescribeActivityInput";
const _DAO = "DeleteActivityOutput";
const _DAOe = "DescribeActivityOutput";
const _DAe = "DescribeActivity";
const _DE = "DescribeExecution";
const _DEI = "DescribeExecutionInput";
const _DEO = "DescribeExecutionOutput";
const _DMR = "DescribeMapRun";
const _DMRI = "DescribeMapRunInput";
const _DMRO = "DescribeMapRunOutput";
const _DSM = "DeleteStateMachine";
const _DSMA = "DeleteStateMachineAlias";
const _DSMAI = "DeleteStateMachineAliasInput";
const _DSMAIe = "DescribeStateMachineAliasInput";
const _DSMAO = "DeleteStateMachineAliasOutput";
const _DSMAOe = "DescribeStateMachineAliasOutput";
const _DSMAe = "DescribeStateMachineAlias";
const _DSMFE = "DescribeStateMachineForExecution";
const _DSMFEI = "DescribeStateMachineForExecutionInput";
const _DSMFEO = "DescribeStateMachineForExecutionOutput";
const _DSMI = "DeleteStateMachineInput";
const _DSMIe = "DescribeStateMachineInput";
const _DSMO = "DeleteStateMachineOutput";
const _DSMOe = "DescribeStateMachineOutput";
const _DSMV = "DeleteStateMachineVersion";
const _DSMVI = "DeleteStateMachineVersionInput";
const _DSMVO = "DeleteStateMachineVersionOutput";
const _DSMe = "DescribeStateMachine";
const _EAE = "ExecutionAlreadyExists";
const _EAED = "ExecutionAbortedEventDetails";
const _EC = "EncryptionConfiguration";
const _EDNE = "ExecutionDoesNotExist";
const _EFED = "EvaluationFailedEventDetails";
const _EFEDx = "ExecutionFailedEventDetails";
const _EFL = "EvaluationFailureLocation";
const _EHI = "ExceptionHandlerIndex";
const _EL = "ExecutionList";
const _ELE = "ExecutionLimitExceeded";
const _ELI = "ExecutionListItem";
const _ENR = "ExecutionNotRedrivable";
const _ERED = "ExecutionRedrivenEventDetails";
const _ESED = "ExecutionStartedEventDetails";
const _ESEDx = "ExecutionSucceededEventDetails";
const _ETOED = "ExecutionTimedOutEventDetails";
const _GAT = "GetActivityTask";
const _GATI = "GetActivityTaskInput";
const _GATO = "GetActivityTaskOutput";
const _GEH = "GetExecutionHistory";
const _GEHI = "GetExecutionHistoryInput";
const _GEHO = "GetExecutionHistoryOutput";
const _HE = "HistoryEvent";
const _HEEDD = "HistoryEventExecutionDataDetails";
const _HEL = "HistoryEventList";
const _IA = "InvalidArn";
const _ID = "InvalidDefinition";
const _IDR = "InspectionDataRequest";
const _IDRn = "InspectionDataResponse";
const _IDn = "InspectionData";
const _IEC = "InvalidEncryptionConfiguration";
const _IED = "InspectionErrorDetails";
const _IEI = "InvalidExecutionInput";
const _ILC = "InvalidLoggingConfiguration";
const _IMC = "InspectionMaxConcurrency";
const _IN = "InvalidName";
const _IO = "InvalidOutput";
const _IT = "InvalidToken";
const _ITC = "InvalidTracingConfiguration";
const _ITFC = "InspectionToleratedFailureCount";
const _ITFP = "InspectionToleratedFailurePercentage";
const _KADE = "KmsAccessDeniedException";
const _KISE = "KmsInvalidStateException";
const _KTE = "KmsThrottlingException";
const _LA = "ListActivities";
const _LAI = "ListActivitiesInput";
const _LAO = "ListActivitiesOutput";
const _LC = "LoggingConfiguration";
const _LD = "LogDestination";
const _LDL = "LogDestinationList";
const _LE = "ListExecutions";
const _LEI = "ListExecutionsInput";
const _LEO = "ListExecutionsOutput";
const _LFFED = "LambdaFunctionFailedEventDetails";
const _LFSED = "LambdaFunctionScheduledEventDetails";
const _LFSEDa = "LambdaFunctionSucceededEventDetails";
const _LFSFED = "LambdaFunctionScheduleFailedEventDetails";
const _LFSFEDa = "LambdaFunctionStartFailedEventDetails";
const _LFTOED = "LambdaFunctionTimedOutEventDetails";
const _LMR = "ListMapRuns";
const _LMRI = "ListMapRunsInput";
const _LMRO = "ListMapRunsOutput";
const _LSM = "ListStateMachines";
const _LSMA = "ListStateMachineAliases";
const _LSMAI = "ListStateMachineAliasesInput";
const _LSMAO = "ListStateMachineAliasesOutput";
const _LSMI = "ListStateMachinesInput";
const _LSMO = "ListStateMachinesOutput";
const _LSMV = "ListStateMachineVersions";
const _LSMVI = "ListStateMachineVersionsInput";
const _LSMVO = "ListStateMachineVersionsOutput";
const _LTFR = "ListTagsForResource";
const _LTFRI = "ListTagsForResourceInput";
const _LTFRO = "ListTagsForResourceOutput";
const _MEO = "MockErrorOutput";
const _MI = "MockInput";
const _MIED = "MapIterationEventDetails";
const _MREC = "MapRunExecutionCounts";
const _MRFED = "MapRunFailedEventDetails";
const _MRIC = "MapRunItemCounts";
const _MRL = "MapRunList";
const _MRLI = "MapRunListItem";
const _MRP = "MissingRequiredParameter";
const _MRRED = "MapRunRedrivenEventDetails";
const _MRSED = "MapRunStartedEventDetails";
const _MSSED = "MapStateStartedEventDetails";
const _PSMV = "PublishStateMachineVersion";
const _PSMVI = "PublishStateMachineVersionInput";
const _PSMVO = "PublishStateMachineVersionOutput";
const _RBIS = "RetryBackoffIntervalSeconds";
const _RCL = "RoutingConfigurationList";
const _RCLI = "RoutingConfigurationListItem";
const _RE = "RedriveExecution";
const _REI = "RedriveExecutionInput";
const _REO = "RedriveExecutionOutput";
const _RNF = "ResourceNotFound";
const _SC = "SensitiveCause";
const _SD = "SensitiveData";
const _SDJI = "SensitiveDataJobInput";
const _SE = "SensitiveError";
const _SEED = "StateEnteredEventDetails";
const _SEEDt = "StateExitedEventDetails";
const _SEI = "StartExecutionInput";
const _SEIt = "StopExecutionInput";
const _SEO = "StartExecutionOutput";
const _SEOt = "StopExecutionOutput";
const _SEt = "StartExecution";
const _SEto = "StopExecution";
const _SMAE = "StateMachineAlreadyExists";
const _SMAL = "StateMachineAliasList";
const _SMALI = "StateMachineAliasListItem";
const _SMD = "StateMachineDeleting";
const _SMDNE = "StateMachineDoesNotExist";
const _SML = "StateMachineList";
const _SMLE = "StateMachineLimitExceeded";
const _SMLI = "StateMachineListItem";
const _SMTNS = "StateMachineTypeNotSupported";
const _SMVL = "StateMachineVersionList";
const _SMVLI = "StateMachineVersionListItem";
const _SQEE = "ServiceQuotaExceededException";
const _SSE = "StartSyncExecution";
const _SSEI = "StartSyncExecutionInput";
const _SSEO = "StartSyncExecutionOutput";
const _STF = "SendTaskFailure";
const _STFI = "SendTaskFailureInput";
const _STFO = "SendTaskFailureOutput";
const _STH = "SendTaskHeartbeat";
const _STHI = "SendTaskHeartbeatInput";
const _STHO = "SendTaskHeartbeatOutput";
const _STS = "SendTaskSuccess";
const _STSI = "SendTaskSuccessInput";
const _STSO = "SendTaskSuccessOutput";
const _T = "Tag";
const _TC = "TaskCredentials";
const _TCr = "TracingConfiguration";
const _TDNE = "TaskDoesNotExist";
const _TFED = "TaskFailedEventDetails";
const _TL = "TagList";
const _TMT = "TooManyTags";
const _TR = "TagResource";
const _TRI = "TagResourceInput";
const _TRO = "TagResourceOutput";
const _TS = "TestState";
const _TSC = "TestStateConfiguration";
const _TSED = "TaskScheduledEventDetails";
const _TSEDa = "TaskStartedEventDetails";
const _TSEDas = "TaskSubmittedEventDetails";
const _TSEDask = "TaskSucceededEventDetails";
const _TSFED = "TaskStartFailedEventDetails";
const _TSFEDa = "TaskSubmitFailedEventDetails";
const _TSI = "TestStateInput";
const _TSO = "TestStateOutput";
const _TSSN = "TestStateStateName";
const _TTO = "TaskTimedOut";
const _TTOED = "TaskTimedOutEventDetails";
const _UMR = "UpdateMapRun";
const _UMRI = "UpdateMapRunInput";
const _UMRO = "UpdateMapRunOutput";
const _UR = "UntagResource";
const _URI = "UntagResourceInput";
const _URO = "UntagResourceOutput";
const _USM = "UpdateStateMachine";
const _USMA = "UpdateStateMachineAlias";
const _USMAI = "UpdateStateMachineAliasInput";
const _USMAO = "UpdateStateMachineAliasOutput";
const _USMI = "UpdateStateMachineInput";
const _USMO = "UpdateStateMachineOutput";
const _VD = "VersionDescription";
const _VE = "ValidationException";
const _VN = "VariableName";
const _VNL = "VariableNameList";
const _VR = "VariableReferences";
const _VSMD = "ValidateStateMachineDefinition";
const _VSMDC = "ValidateStateMachineDefinitionCode";
const _VSMDD = "ValidateStateMachineDefinitionDiagnostic";
const _VSMDDL = "ValidateStateMachineDefinitionDiagnosticList";
const _VSMDI = "ValidateStateMachineDefinitionInput";
const _VSMDL = "ValidateStateMachineDefinitionLocation";
const _VSMDM = "ValidateStateMachineDefinitionMessage";
const _VSMDO = "ValidateStateMachineDefinitionOutput";
const _VV = "VariableValue";
const _a = "activities";
const _aA = "activityArn";
const _aAf = "afterArguments";
const _aFED = "activityFailedEventDetails";
const _aIB = "afterItemBatcher";
const _aIP = "afterInputPath";
const _aIPf = "afterItemsPath";
const _aIPft = "afterItemsPointer";
const _aIS = "afterItemSelector";
const _aP = "afterParameters";
const _aRP = "afterResultPath";
const _aRS = "afterResultSelector";
const _aSED = "activityScheduledEventDetails";
const _aSEDc = "activityStartedEventDetails";
const _aSEDct = "activitySucceededEventDetails";
const _aSFED = "activityScheduleFailedEventDetails";
const _aTOED = "activityTimedOutEventDetails";
const _aV = "assignedVariables";
const _aVD = "assignedVariablesDetails";
const _ab = "aborted";
const _b = "body";
const _bD = "billingDetails";
const _bDIM = "billedDurationInMilliseconds";
const _bMUIMB = "billedMemoryUsedInMB";
const _c = "client";
const _cD = "creationDate";
const _cI = "catchIndex";
const _cT = "clientToken";
const _cWLLG = "cloudWatchLogsLogGroup";
const _ca = "cause";
const _co = "context";
const _cod = "code";
const _d = "description";
const _de = "definition";
const _des = "destinations";
const _di = "diagnostics";
const _e = "error";
const _eA = "executionArn";
const _eAED = "executionAbortedEventDetails";
const _eC = "encryptionConfiguration";
const _eCBS = "errorCausedByState";
const _eCx = "executionCounts";
const _eD = "errorDetails";
const _eFED = "executionFailedEventDetails";
const _eFEDv = "evaluationFailedEventDetails";
const _eO = "errorOutput";
const _eRED = "executionRedrivenEventDetails";
const _eSED = "executionStartedEventDetails";
const _eSEDx = "executionSucceededEventDetails";
const _eTOED = "executionTimedOutEventDetails";
const _en = "enabled";
const _end = "endpoint";
const _ev = "events";
const _ex = "executions";
const _f = "failed";
const _fNR = "failuresNotRedrivable";
const _fVM = "fieldValidationMode";
const _h = "headers";
const _hE = "httpError";
const _hIS = "heartbeatInSeconds";
const _i = "input";
const _iC = "itemCounts";
const _iCt = "itemCount";
const _iD = "inputDetails";
const _iDn = "includedData";
const _iDns = "inspectionData";
const _iED = "includeExecutionData";
const _iL = "inspectionLevel";
const _id = "id";
const _in = "included";
const _ind = "index";
const _k = "key";
const _kDKRPS = "kmsDataKeyReusePeriodSeconds";
const _kKI = "kmsKeyId";
const _kKS = "kmsKeyState";
const _l = "label";
const _lC = "loggingConfiguration";
const _lFFED = "lambdaFunctionFailedEventDetails";
const _lFSED = "lambdaFunctionScheduledEventDetails";
const _lFSEDa = "lambdaFunctionSucceededEventDetails";
const _lFSFED = "lambdaFunctionScheduleFailedEventDetails";
const _lFSFEDa = "lambdaFunctionStartFailedEventDetails";
const _lFTOED = "lambdaFunctionTimedOutEventDetails";
const _lGA = "logGroupArn";
const _le = "level";
const _len = "length";
const _lo = "location";
const _m = "message";
const _mC = "maxConcurrency";
const _mIAED = "mapIterationAbortedEventDetails";
const _mIFC = "mapIterationFailureCount";
const _mIFED = "mapIterationFailedEventDetails";
const _mIRD = "mapItemReaderData";
const _mISED = "mapIterationStartedEventDetails";
const _mISEDa = "mapIterationSucceededEventDetails";
const _mR = "maxResults";
const _mRA = "mapRunArn";
const _mRFED = "mapRunFailedEventDetails";
const _mRRED = "mapRunRedrivenEventDetails";
const _mRSED = "mapRunStartedEventDetails";
const _mRa = "mapRuns";
const _mSSED = "mapStateStartedEventDetails";
const _me = "method";
const _mo = "mock";
const _n = "name";
const _nS = "nextState";
const _nT = "nextToken";
const _o = "output";
const _oD = "outputDetails";
const _p = "publish";
const _pEI = "previousEventId";
const _pR = "pendingRedrive";
const _pa = "parameters";
const _pe = "pending";
const _pr = "protocol";
const _r = "reason";
const _rA = "roleArn";
const _rAe = "resourceArn";
const _rBIS = "retryBackoffIntervalSeconds";
const _rC = "routingConfiguration";
const _rCe = "redriveCount";
const _rD = "redriveDate";
const _rF = "redriveFilter";
const _rI = "revisionId";
const _rIe = "retryIndex";
const _rN = "resourceName";
const _rO = "reverseOrder";
const _rRC = "retrierRetryCount";
const _rS = "redriveStatus";
const _rSR = "redriveStatusReason";
const _rSe = "revealSecrets";
const _rT = "resourceType";
const _rW = "resultsWritten";
const _re = "resource";
const _reg = "region";
const _req = "request";
const _res = "result";
const _resp = "response";
const _ru = "running";
const _s = "smithy.ts.sdk.synthetic.com.amazonaws.sfn";
const _sC = "statusCode";
const _sCt = "stateConfiguration";
const _sD = "startDate";
const _sDt = "stopDate";
const _sEED = "stateEnteredEventDetails";
const _sEEDt = "stateExitedEventDetails";
const _sF = "statusFilter";
const _sM = "statusMessage";
const _sMA = "stateMachineArn";
const _sMAA = "stateMachineAliasArn";
const _sMAt = "stateMachineAliases";
const _sMV = "stateMachineVersions";
const _sMVA = "stateMachineVersionArn";
const _sMt = "stateMachines";
const _sN = "stateName";
const _se = "severity";
const _st = "status";
const _sta = "state";
const _su = "succeeded";
const _t = "truncated";
const _tC = "tracingConfiguration";
const _tCa = "taskCredentials";
const _tFC = "toleratedFailureCount";
const _tFED = "taskFailedEventDetails";
const _tFP = "toleratedFailurePercentage";
const _tH = "traceHeader";
const _tIS = "timeoutInSeconds";
const _tK = "tagKeys";
const _tO = "timedOut";
const _tSED = "taskScheduledEventDetails";
const _tSEDa = "taskStartedEventDetails";
const _tSEDas = "taskSubmittedEventDetails";
const _tSEDask = "taskSucceededEventDetails";
const _tSFED = "taskStartFailedEventDetails";
const _tSFEDa = "taskSubmitFailedEventDetails";
const _tT = "taskToken";
const _tTOED = "taskTimedOutEventDetails";
const _ta = "tags";
const _ti = "timestamp";
const _to = "total";
const _ty = "type";
const _u = "url";
const _uD = "updateDate";
const _v = "variables";
const _vD = "versionDescription";
const _vR = "variableReferences";
const _va = "value";
const _w = "weight";
const _wN = "workerName";
const n0 = "com.amazonaws.sfn";
const schema_1 = require("@smithy/core/schema");
const errors_1 = require("../models/errors");
const SFNServiceException_1 = require("../models/SFNServiceException");
const _s_registry = schema_1.TypeRegistry.for(_s);
exports.SFNServiceException$ = [-3, _s, "SFNServiceException", 0, [], []];
_s_registry.registerError(exports.SFNServiceException$, SFNServiceException_1.SFNServiceException);
const n0_registry = schema_1.TypeRegistry.for(n0);
exports.ActivityAlreadyExists$ = [-3, n0, _AAE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ActivityAlreadyExists$, errors_1.ActivityAlreadyExists);
exports.ActivityDoesNotExist$ = [-3, n0, _ADNE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ActivityDoesNotExist$, errors_1.ActivityDoesNotExist);
exports.ActivityLimitExceeded$ = [-3, n0, _ALE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ActivityLimitExceeded$, errors_1.ActivityLimitExceeded);
exports.ActivityWorkerLimitExceeded$ = [-3, n0, _AWLE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ActivityWorkerLimitExceeded$, errors_1.ActivityWorkerLimitExceeded);
exports.ConflictException$ = [-3, n0, _CE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ConflictException$, errors_1.ConflictException);
exports.ExecutionAlreadyExists$ = [-3, n0, _EAE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ExecutionAlreadyExists$, errors_1.ExecutionAlreadyExists);
exports.ExecutionDoesNotExist$ = [-3, n0, _EDNE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ExecutionDoesNotExist$, errors_1.ExecutionDoesNotExist);
exports.ExecutionLimitExceeded$ = [-3, n0, _ELE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ExecutionLimitExceeded$, errors_1.ExecutionLimitExceeded);
exports.ExecutionNotRedrivable$ = [-3, n0, _ENR,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.ExecutionNotRedrivable$, errors_1.ExecutionNotRedrivable);
exports.InvalidArn$ = [-3, n0, _IA,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidArn$, errors_1.InvalidArn);
exports.InvalidDefinition$ = [-3, n0, _ID,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidDefinition$, errors_1.InvalidDefinition);
exports.InvalidEncryptionConfiguration$ = [-3, n0, _IEC,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidEncryptionConfiguration$, errors_1.InvalidEncryptionConfiguration);
exports.InvalidExecutionInput$ = [-3, n0, _IEI,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidExecutionInput$, errors_1.InvalidExecutionInput);
exports.InvalidLoggingConfiguration$ = [-3, n0, _ILC,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidLoggingConfiguration$, errors_1.InvalidLoggingConfiguration);
exports.InvalidName$ = [-3, n0, _IN,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidName$, errors_1.InvalidName);
exports.InvalidOutput$ = [-3, n0, _IO,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidOutput$, errors_1.InvalidOutput);
exports.InvalidToken$ = [-3, n0, _IT,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidToken$, errors_1.InvalidToken);
exports.InvalidTracingConfiguration$ = [-3, n0, _ITC,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidTracingConfiguration$, errors_1.InvalidTracingConfiguration);
exports.KmsAccessDeniedException$ = [-3, n0, _KADE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.KmsAccessDeniedException$, errors_1.KmsAccessDeniedException);
exports.KmsInvalidStateException$ = [-3, n0, _KISE,
    { [_e]: _c },
    [_kKS, _m],
    [0, 0]
];
n0_registry.registerError(exports.KmsInvalidStateException$, errors_1.KmsInvalidStateException);
exports.KmsThrottlingException$ = [-3, n0, _KTE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.KmsThrottlingException$, errors_1.KmsThrottlingException);
exports.MissingRequiredParameter$ = [-3, n0, _MRP,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.MissingRequiredParameter$, errors_1.MissingRequiredParameter);
exports.ResourceNotFound$ = [-3, n0, _RNF,
    { [_e]: _c, [_hE]: 404 },
    [_m, _rN],
    [0, 0]
];
n0_registry.registerError(exports.ResourceNotFound$, errors_1.ResourceNotFound);
exports.ServiceQuotaExceededException$ = [-3, n0, _SQEE,
    { [_e]: _c, [_hE]: 402 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ServiceQuotaExceededException$, errors_1.ServiceQuotaExceededException);
exports.StateMachineAlreadyExists$ = [-3, n0, _SMAE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.StateMachineAlreadyExists$, errors_1.StateMachineAlreadyExists);
exports.StateMachineDeleting$ = [-3, n0, _SMD,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.StateMachineDeleting$, errors_1.StateMachineDeleting);
exports.StateMachineDoesNotExist$ = [-3, n0, _SMDNE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.StateMachineDoesNotExist$, errors_1.StateMachineDoesNotExist);
exports.StateMachineLimitExceeded$ = [-3, n0, _SMLE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.StateMachineLimitExceeded$, errors_1.StateMachineLimitExceeded);
exports.StateMachineTypeNotSupported$ = [-3, n0, _SMTNS,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.StateMachineTypeNotSupported$, errors_1.StateMachineTypeNotSupported);
exports.TaskDoesNotExist$ = [-3, n0, _TDNE,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.TaskDoesNotExist$, errors_1.TaskDoesNotExist);
exports.TaskTimedOut$ = [-3, n0, _TTO,
    { [_e]: _c },
    [_m],
    [0]
];
n0_registry.registerError(exports.TaskTimedOut$, errors_1.TaskTimedOut);
exports.TooManyTags$ = [-3, n0, _TMT,
    { [_e]: _c, [_hE]: 400 },
    [_m, _rN],
    [0, 0]
];
n0_registry.registerError(exports.TooManyTags$, errors_1.TooManyTags);
exports.ValidationException$ = [-3, n0, _VE,
    { [_e]: _c, [_hE]: 400 },
    [_m, _r],
    [0, 0]
];
n0_registry.registerError(exports.ValidationException$, errors_1.ValidationException);
exports.errorTypeRegistries = [
    _s_registry,
    n0_registry,
];
var AliasDescription = [0, n0, _AD, 8, 0];
var ConnectorParameters = [0, n0, _CP, 8, 0];
var Definition = [0, n0, _D, 8, 0];
var EvaluationFailureLocation = [0, n0, _EFL, 8, 0];
var ExceptionHandlerIndex = [0, n0, _EHI, 8, 1];
var InspectionMaxConcurrency = [0, n0, _IMC, 8, 1];
var InspectionToleratedFailureCount = [0, n0, _ITFC, 8, 1];
var InspectionToleratedFailurePercentage = [0, n0, _ITFP, 8, 1];
var RetryBackoffIntervalSeconds = [0, n0, _RBIS, 8, 1];
var SensitiveCause = [0, n0, _SC, 8, 0];
var SensitiveData = [0, n0, _SD, 8, 0];
var SensitiveDataJobInput = [0, n0, _SDJI, 8, 0];
var SensitiveError = [0, n0, _SE, 8, 0];
var TestStateStateName = [0, n0, _TSSN, 8, 0];
var ValidateStateMachineDefinitionCode = [0, n0, _VSMDC, 8, 0];
var ValidateStateMachineDefinitionLocation = [0, n0, _VSMDL, 8, 0];
var ValidateStateMachineDefinitionMessage = [0, n0, _VSMDM, 8, 0];
var VariableName = [0, n0, _VN, 8, 0];
var VariableValue = [0, n0, _VV, 8, 0];
var VersionDescription = [0, n0, _VD, 8, 0];
exports.ActivityFailedEventDetails$ = [3, n0, _AFED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.ActivityListItem$ = [3, n0, _ALI,
    0,
    [_aA, _n, _cD],
    [0, 0, 4], 3
];
exports.ActivityScheduledEventDetails$ = [3, n0, _ASED,
    0,
    [_re, _i, _iD, _tIS, _hIS],
    [0, [() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$, 1, 1], 1
];
exports.ActivityScheduleFailedEventDetails$ = [3, n0, _ASFED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.ActivityStartedEventDetails$ = [3, n0, _ASEDc,
    0,
    [_wN],
    [0]
];
exports.ActivitySucceededEventDetails$ = [3, n0, _ASEDct,
    0,
    [_o, _oD],
    [[() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$]
];
exports.ActivityTimedOutEventDetails$ = [3, n0, _ATOED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.AssignedVariablesDetails$ = [3, n0, _AVD,
    0,
    [_t],
    [2]
];
exports.BillingDetails$ = [3, n0, _BD,
    0,
    [_bMUIMB, _bDIM],
    [1, 1]
];
exports.CloudWatchEventsExecutionDataDetails$ = [3, n0, _CWEEDD,
    0,
    [_in],
    [2]
];
exports.CloudWatchLogsLogGroup$ = [3, n0, _CWLLG,
    0,
    [_lGA],
    [0]
];
exports.CreateActivityInput$ = [3, n0, _CAI,
    0,
    [_n, _ta, _eC],
    [0, () => TagList, () => exports.EncryptionConfiguration$], 1
];
exports.CreateActivityOutput$ = [3, n0, _CAO,
    0,
    [_aA, _cD],
    [0, 4], 2
];
exports.CreateStateMachineAliasInput$ = [3, n0, _CSMAI,
    0,
    [_n, _rC, _d],
    [0, () => RoutingConfigurationList, [() => AliasDescription, 0]], 2
];
exports.CreateStateMachineAliasOutput$ = [3, n0, _CSMAO,
    0,
    [_sMAA, _cD],
    [0, 4], 2
];
exports.CreateStateMachineInput$ = [3, n0, _CSMI,
    0,
    [_n, _de, _rA, _ty, _lC, _ta, _tC, _p, _vD, _eC],
    [0, [() => Definition, 0], 0, 0, () => exports.LoggingConfiguration$, () => TagList, () => exports.TracingConfiguration$, 2, [() => VersionDescription, 0], () => exports.EncryptionConfiguration$], 3
];
exports.CreateStateMachineOutput$ = [3, n0, _CSMO,
    0,
    [_sMA, _cD, _sMVA],
    [0, 4, 0], 2
];
exports.DeleteActivityInput$ = [3, n0, _DAI,
    0,
    [_aA],
    [0], 1
];
exports.DeleteActivityOutput$ = [3, n0, _DAO,
    0,
    [],
    []
];
exports.DeleteStateMachineAliasInput$ = [3, n0, _DSMAI,
    0,
    [_sMAA],
    [0], 1
];
exports.DeleteStateMachineAliasOutput$ = [3, n0, _DSMAO,
    0,
    [],
    []
];
exports.DeleteStateMachineInput$ = [3, n0, _DSMI,
    0,
    [_sMA],
    [0], 1
];
exports.DeleteStateMachineOutput$ = [3, n0, _DSMO,
    0,
    [],
    []
];
exports.DeleteStateMachineVersionInput$ = [3, n0, _DSMVI,
    0,
    [_sMVA],
    [0], 1
];
exports.DeleteStateMachineVersionOutput$ = [3, n0, _DSMVO,
    0,
    [],
    []
];
exports.DescribeActivityInput$ = [3, n0, _DAIe,
    0,
    [_aA],
    [0], 1
];
exports.DescribeActivityOutput$ = [3, n0, _DAOe,
    0,
    [_aA, _n, _cD, _eC],
    [0, 0, 4, () => exports.EncryptionConfiguration$], 3
];
exports.DescribeExecutionInput$ = [3, n0, _DEI,
    0,
    [_eA, _iDn],
    [0, 0], 1
];
exports.DescribeExecutionOutput$ = [3, n0, _DEO,
    0,
    [_eA, _sMA, _st, _sD, _n, _sDt, _i, _iD, _o, _oD, _tH, _mRA, _e, _ca, _sMVA, _sMAA, _rCe, _rD, _rS, _rSR],
    [0, 0, 0, 4, 0, 4, [() => SensitiveData, 0], () => exports.CloudWatchEventsExecutionDataDetails$, [() => SensitiveData, 0], () => exports.CloudWatchEventsExecutionDataDetails$, 0, 0, [() => SensitiveError, 0], [() => SensitiveCause, 0], 0, 0, 1, 4, 0, [() => SensitiveData, 0]], 4
];
exports.DescribeMapRunInput$ = [3, n0, _DMRI,
    0,
    [_mRA],
    [0], 1
];
exports.DescribeMapRunOutput$ = [3, n0, _DMRO,
    0,
    [_mRA, _eA, _st, _sD, _mC, _tFP, _tFC, _iC, _eCx, _sDt, _rCe, _rD],
    [0, 0, 0, 4, 1, 1, 1, () => exports.MapRunItemCounts$, () => exports.MapRunExecutionCounts$, 4, 1, 4], 9
];
exports.DescribeStateMachineAliasInput$ = [3, n0, _DSMAIe,
    0,
    [_sMAA],
    [0], 1
];
exports.DescribeStateMachineAliasOutput$ = [3, n0, _DSMAOe,
    0,
    [_sMAA, _n, _d, _rC, _cD, _uD],
    [0, 0, [() => AliasDescription, 0], () => RoutingConfigurationList, 4, 4]
];
exports.DescribeStateMachineForExecutionInput$ = [3, n0, _DSMFEI,
    0,
    [_eA, _iDn],
    [0, 0], 1
];
exports.DescribeStateMachineForExecutionOutput$ = [3, n0, _DSMFEO,
    0,
    [_sMA, _n, _de, _rA, _uD, _lC, _tC, _mRA, _l, _rI, _eC, _vR],
    [0, 0, [() => Definition, 0], 0, 4, () => exports.LoggingConfiguration$, () => exports.TracingConfiguration$, 0, 0, 0, () => exports.EncryptionConfiguration$, [() => VariableReferences, 0]], 5
];
exports.DescribeStateMachineInput$ = [3, n0, _DSMIe,
    0,
    [_sMA, _iDn],
    [0, 0], 1
];
exports.DescribeStateMachineOutput$ = [3, n0, _DSMOe,
    0,
    [_sMA, _n, _de, _rA, _ty, _cD, _st, _lC, _tC, _l, _rI, _d, _eC, _vR],
    [0, 0, [() => Definition, 0], 0, 0, 4, 0, () => exports.LoggingConfiguration$, () => exports.TracingConfiguration$, 0, 0, [() => VersionDescription, 0], () => exports.EncryptionConfiguration$, [() => VariableReferences, 0]], 6
];
exports.EncryptionConfiguration$ = [3, n0, _EC,
    0,
    [_ty, _kKI, _kDKRPS],
    [0, 0, 1], 1
];
exports.EvaluationFailedEventDetails$ = [3, n0, _EFED,
    0,
    [_sta, _e, _ca, _lo],
    [0, [() => SensitiveError, 0], [() => SensitiveCause, 0], [() => EvaluationFailureLocation, 0]], 1
];
exports.ExecutionAbortedEventDetails$ = [3, n0, _EAED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.ExecutionFailedEventDetails$ = [3, n0, _EFEDx,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.ExecutionListItem$ = [3, n0, _ELI,
    0,
    [_eA, _sMA, _n, _st, _sD, _sDt, _mRA, _iCt, _sMVA, _sMAA, _rCe, _rD],
    [0, 0, 0, 0, 4, 4, 0, 1, 0, 0, 1, 4], 5
];
exports.ExecutionRedrivenEventDetails$ = [3, n0, _ERED,
    0,
    [_rCe],
    [1]
];
exports.ExecutionStartedEventDetails$ = [3, n0, _ESED,
    0,
    [_i, _iD, _rA, _sMAA, _sMVA],
    [[() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$, 0, 0, 0]
];
exports.ExecutionSucceededEventDetails$ = [3, n0, _ESEDx,
    0,
    [_o, _oD],
    [[() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$]
];
exports.ExecutionTimedOutEventDetails$ = [3, n0, _ETOED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.GetActivityTaskInput$ = [3, n0, _GATI,
    0,
    [_aA, _wN],
    [0, 0], 1
];
exports.GetActivityTaskOutput$ = [3, n0, _GATO,
    0,
    [_tT, _i],
    [0, [() => SensitiveDataJobInput, 0]]
];
exports.GetExecutionHistoryInput$ = [3, n0, _GEHI,
    0,
    [_eA, _mR, _rO, _nT, _iED],
    [0, 1, 2, 0, 2], 1
];
exports.GetExecutionHistoryOutput$ = [3, n0, _GEHO,
    0,
    [_ev, _nT],
    [[() => HistoryEventList, 0], 0], 1
];
exports.HistoryEvent$ = [3, n0, _HE,
    0,
    [_ti, _ty, _id, _pEI, _aFED, _aSFED, _aSED, _aSEDc, _aSEDct, _aTOED, _tFED, _tSED, _tSFED, _tSEDa, _tSFEDa, _tSEDas, _tSEDask, _tTOED, _eFED, _eSED, _eSEDx, _eAED, _eTOED, _eRED, _mSSED, _mISED, _mISEDa, _mIFED, _mIAED, _lFFED, _lFSFED, _lFSED, _lFSFEDa, _lFSEDa, _lFTOED, _sEED, _sEEDt, _mRSED, _mRFED, _mRRED, _eFEDv],
    [4, 0, 1, 1, [() => exports.ActivityFailedEventDetails$, 0], [() => exports.ActivityScheduleFailedEventDetails$, 0], [() => exports.ActivityScheduledEventDetails$, 0], () => exports.ActivityStartedEventDetails$, [() => exports.ActivitySucceededEventDetails$, 0], [() => exports.ActivityTimedOutEventDetails$, 0], [() => exports.TaskFailedEventDetails$, 0], [() => exports.TaskScheduledEventDetails$, 0], [() => exports.TaskStartFailedEventDetails$, 0], () => exports.TaskStartedEventDetails$, [() => exports.TaskSubmitFailedEventDetails$, 0], [() => exports.TaskSubmittedEventDetails$, 0], [() => exports.TaskSucceededEventDetails$, 0], [() => exports.TaskTimedOutEventDetails$, 0], [() => exports.ExecutionFailedEventDetails$, 0], [() => exports.ExecutionStartedEventDetails$, 0], [() => exports.ExecutionSucceededEventDetails$, 0], [() => exports.ExecutionAbortedEventDetails$, 0], [() => exports.ExecutionTimedOutEventDetails$, 0], () => exports.ExecutionRedrivenEventDetails$, () => exports.MapStateStartedEventDetails$, () => exports.MapIterationEventDetails$, () => exports.MapIterationEventDetails$, () => exports.MapIterationEventDetails$, () => exports.MapIterationEventDetails$, [() => exports.LambdaFunctionFailedEventDetails$, 0], [() => exports.LambdaFunctionScheduleFailedEventDetails$, 0], [() => exports.LambdaFunctionScheduledEventDetails$, 0], [() => exports.LambdaFunctionStartFailedEventDetails$, 0], [() => exports.LambdaFunctionSucceededEventDetails$, 0], [() => exports.LambdaFunctionTimedOutEventDetails$, 0], [() => exports.StateEnteredEventDetails$, 0], [() => exports.StateExitedEventDetails$, 0], () => exports.MapRunStartedEventDetails$, [() => exports.MapRunFailedEventDetails$, 0], () => exports.MapRunRedrivenEventDetails$, [() => exports.EvaluationFailedEventDetails$, 0]], 3
];
exports.HistoryEventExecutionDataDetails$ = [3, n0, _HEEDD,
    0,
    [_t],
    [2]
];
exports.InspectionData$ = [3, n0, _IDn,
    8,
    [_i, _aAf, _aIP, _aP, _res, _aRS, _aRP, _req, _resp, _v, _eD, _aIPf, _aIS, _aIB, _aIPft, _tFC, _tFP, _mC],
    [[() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], () => exports.InspectionDataRequest$, () => exports.InspectionDataResponse$, [() => SensitiveData, 0], [() => exports.InspectionErrorDetails$, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => SensitiveData, 0], [() => InspectionToleratedFailureCount, 0], [() => InspectionToleratedFailurePercentage, 0], [() => InspectionMaxConcurrency, 0]]
];
exports.InspectionDataRequest$ = [3, n0, _IDR,
    0,
    [_pr, _me, _u, _h, _b],
    [0, 0, 0, 0, 0]
];
exports.InspectionDataResponse$ = [3, n0, _IDRn,
    0,
    [_pr, _sC, _sM, _h, _b],
    [0, 0, 0, 0, 0]
];
exports.InspectionErrorDetails$ = [3, n0, _IED,
    0,
    [_cI, _rIe, _rBIS],
    [[() => ExceptionHandlerIndex, 0], [() => ExceptionHandlerIndex, 0], [() => RetryBackoffIntervalSeconds, 0]]
];
exports.LambdaFunctionFailedEventDetails$ = [3, n0, _LFFED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.LambdaFunctionScheduledEventDetails$ = [3, n0, _LFSED,
    0,
    [_re, _i, _iD, _tIS, _tCa],
    [0, [() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$, 1, () => exports.TaskCredentials$], 1
];
exports.LambdaFunctionScheduleFailedEventDetails$ = [3, n0, _LFSFED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.LambdaFunctionStartFailedEventDetails$ = [3, n0, _LFSFEDa,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.LambdaFunctionSucceededEventDetails$ = [3, n0, _LFSEDa,
    0,
    [_o, _oD],
    [[() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$]
];
exports.LambdaFunctionTimedOutEventDetails$ = [3, n0, _LFTOED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.ListActivitiesInput$ = [3, n0, _LAI,
    0,
    [_mR, _nT],
    [1, 0]
];
exports.ListActivitiesOutput$ = [3, n0, _LAO,
    0,
    [_a, _nT],
    [() => ActivityList, 0], 1
];
exports.ListExecutionsInput$ = [3, n0, _LEI,
    0,
    [_sMA, _sF, _mR, _nT, _mRA, _rF],
    [0, 0, 1, 0, 0, 0]
];
exports.ListExecutionsOutput$ = [3, n0, _LEO,
    0,
    [_ex, _nT],
    [() => ExecutionList, 0], 1
];
exports.ListMapRunsInput$ = [3, n0, _LMRI,
    0,
    [_eA, _mR, _nT],
    [0, 1, 0], 1
];
exports.ListMapRunsOutput$ = [3, n0, _LMRO,
    0,
    [_mRa, _nT],
    [() => MapRunList, 0], 1
];
exports.ListStateMachineAliasesInput$ = [3, n0, _LSMAI,
    0,
    [_sMA, _nT, _mR],
    [0, 0, 1], 1
];
exports.ListStateMachineAliasesOutput$ = [3, n0, _LSMAO,
    0,
    [_sMAt, _nT],
    [() => StateMachineAliasList, 0], 1
];
exports.ListStateMachinesInput$ = [3, n0, _LSMI,
    0,
    [_mR, _nT],
    [1, 0]
];
exports.ListStateMachinesOutput$ = [3, n0, _LSMO,
    0,
    [_sMt, _nT],
    [() => StateMachineList, 0], 1
];
exports.ListStateMachineVersionsInput$ = [3, n0, _LSMVI,
    0,
    [_sMA, _nT, _mR],
    [0, 0, 1], 1
];
exports.ListStateMachineVersionsOutput$ = [3, n0, _LSMVO,
    0,
    [_sMV, _nT],
    [() => StateMachineVersionList, 0], 1
];
exports.ListTagsForResourceInput$ = [3, n0, _LTFRI,
    0,
    [_rAe],
    [0], 1
];
exports.ListTagsForResourceOutput$ = [3, n0, _LTFRO,
    0,
    [_ta],
    [() => TagList]
];
exports.LogDestination$ = [3, n0, _LD,
    0,
    [_cWLLG],
    [() => exports.CloudWatchLogsLogGroup$]
];
exports.LoggingConfiguration$ = [3, n0, _LC,
    0,
    [_le, _iED, _des],
    [0, 2, () => LogDestinationList]
];
exports.MapIterationEventDetails$ = [3, n0, _MIED,
    0,
    [_n, _ind],
    [0, 1]
];
exports.MapRunExecutionCounts$ = [3, n0, _MREC,
    0,
    [_pe, _ru, _su, _f, _tO, _ab, _to, _rW, _fNR, _pR],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1], 8
];
exports.MapRunFailedEventDetails$ = [3, n0, _MRFED,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.MapRunItemCounts$ = [3, n0, _MRIC,
    0,
    [_pe, _ru, _su, _f, _tO, _ab, _to, _rW, _fNR, _pR],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1], 8
];
exports.MapRunListItem$ = [3, n0, _MRLI,
    0,
    [_eA, _mRA, _sMA, _sD, _sDt],
    [0, 0, 0, 4, 4], 4
];
exports.MapRunRedrivenEventDetails$ = [3, n0, _MRRED,
    0,
    [_mRA, _rCe],
    [0, 1]
];
exports.MapRunStartedEventDetails$ = [3, n0, _MRSED,
    0,
    [_mRA],
    [0]
];
exports.MapStateStartedEventDetails$ = [3, n0, _MSSED,
    0,
    [_len],
    [1]
];
exports.MockErrorOutput$ = [3, n0, _MEO,
    0,
    [_e, _ca],
    [[() => SensitiveError, 0], [() => SensitiveCause, 0]]
];
exports.MockInput$ = [3, n0, _MI,
    0,
    [_res, _eO, _fVM],
    [[() => SensitiveData, 0], [() => exports.MockErrorOutput$, 0], 0]
];
exports.PublishStateMachineVersionInput$ = [3, n0, _PSMVI,
    0,
    [_sMA, _rI, _d],
    [0, 0, [() => VersionDescription, 0]], 1
];
exports.PublishStateMachineVersionOutput$ = [3, n0, _PSMVO,
    0,
    [_cD, _sMVA],
    [4, 0], 2
];
exports.RedriveExecutionInput$ = [3, n0, _REI,
    0,
    [_eA, _cT],
    [0, [0, 4]], 1
];
exports.RedriveExecutionOutput$ = [3, n0, _REO,
    0,
    [_rD],
    [4], 1
];
exports.RoutingConfigurationListItem$ = [3, n0, _RCLI,
    0,
    [_sMVA, _w],
    [0, 1], 2
];
exports.SendTaskFailureInput$ = [3, n0, _STFI,
    0,
    [_tT, _e, _ca],
    [0, [() => SensitiveError, 0], [() => SensitiveCause, 0]], 1
];
exports.SendTaskFailureOutput$ = [3, n0, _STFO,
    0,
    [],
    []
];
exports.SendTaskHeartbeatInput$ = [3, n0, _STHI,
    0,
    [_tT],
    [0], 1
];
exports.SendTaskHeartbeatOutput$ = [3, n0, _STHO,
    0,
    [],
    []
];
exports.SendTaskSuccessInput$ = [3, n0, _STSI,
    0,
    [_tT, _o],
    [0, [() => SensitiveData, 0]], 2
];
exports.SendTaskSuccessOutput$ = [3, n0, _STSO,
    0,
    [],
    []
];
exports.StartExecutionInput$ = [3, n0, _SEI,
    0,
    [_sMA, _n, _i, _tH],
    [0, 0, [() => SensitiveData, 0], 0], 1
];
exports.StartExecutionOutput$ = [3, n0, _SEO,
    0,
    [_eA, _sD],
    [0, 4], 2
];
exports.StartSyncExecutionInput$ = [3, n0, _SSEI,
    0,
    [_sMA, _n, _i, _tH, _iDn],
    [0, 0, [() => SensitiveData, 0], 0, 0], 1
];
exports.StartSyncExecutionOutput$ = [3, n0, _SSEO,
    0,
    [_eA, _sD, _sDt, _st, _sMA, _n, _e, _ca, _i, _iD, _o, _oD, _tH, _bD],
    [0, 4, 4, 0, 0, 0, [() => SensitiveError, 0], [() => SensitiveCause, 0], [() => SensitiveData, 0], () => exports.CloudWatchEventsExecutionDataDetails$, [() => SensitiveData, 0], () => exports.CloudWatchEventsExecutionDataDetails$, 0, () => exports.BillingDetails$], 4
];
exports.StateEnteredEventDetails$ = [3, n0, _SEED,
    0,
    [_n, _i, _iD],
    [0, [() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$], 1
];
exports.StateExitedEventDetails$ = [3, n0, _SEEDt,
    0,
    [_n, _o, _oD, _aV, _aVD],
    [0, [() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$, [() => AssignedVariables, 0], () => exports.AssignedVariablesDetails$], 1
];
exports.StateMachineAliasListItem$ = [3, n0, _SMALI,
    0,
    [_sMAA, _cD],
    [0, 4], 2
];
exports.StateMachineListItem$ = [3, n0, _SMLI,
    0,
    [_sMA, _n, _ty, _cD],
    [0, 0, 0, 4], 4
];
exports.StateMachineVersionListItem$ = [3, n0, _SMVLI,
    0,
    [_sMVA, _cD],
    [0, 4], 2
];
exports.StopExecutionInput$ = [3, n0, _SEIt,
    0,
    [_eA, _e, _ca],
    [0, [() => SensitiveError, 0], [() => SensitiveCause, 0]], 1
];
exports.StopExecutionOutput$ = [3, n0, _SEOt,
    0,
    [_sDt],
    [4], 1
];
exports.Tag$ = [3, n0, _T,
    0,
    [_k, _va],
    [0, 0]
];
exports.TagResourceInput$ = [3, n0, _TRI,
    0,
    [_rAe, _ta],
    [0, () => TagList], 2
];
exports.TagResourceOutput$ = [3, n0, _TRO,
    0,
    [],
    []
];
exports.TaskCredentials$ = [3, n0, _TC,
    0,
    [_rA],
    [0]
];
exports.TaskFailedEventDetails$ = [3, n0, _TFED,
    0,
    [_rT, _re, _e, _ca],
    [0, 0, [() => SensitiveError, 0], [() => SensitiveCause, 0]], 2
];
exports.TaskScheduledEventDetails$ = [3, n0, _TSED,
    0,
    [_rT, _re, _reg, _pa, _tIS, _hIS, _tCa],
    [0, 0, 0, [() => ConnectorParameters, 0], 1, 1, () => exports.TaskCredentials$], 4
];
exports.TaskStartedEventDetails$ = [3, n0, _TSEDa,
    0,
    [_rT, _re],
    [0, 0], 2
];
exports.TaskStartFailedEventDetails$ = [3, n0, _TSFED,
    0,
    [_rT, _re, _e, _ca],
    [0, 0, [() => SensitiveError, 0], [() => SensitiveCause, 0]], 2
];
exports.TaskSubmitFailedEventDetails$ = [3, n0, _TSFEDa,
    0,
    [_rT, _re, _e, _ca],
    [0, 0, [() => SensitiveError, 0], [() => SensitiveCause, 0]], 2
];
exports.TaskSubmittedEventDetails$ = [3, n0, _TSEDas,
    0,
    [_rT, _re, _o, _oD],
    [0, 0, [() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$], 2
];
exports.TaskSucceededEventDetails$ = [3, n0, _TSEDask,
    0,
    [_rT, _re, _o, _oD],
    [0, 0, [() => SensitiveData, 0], () => exports.HistoryEventExecutionDataDetails$], 2
];
exports.TaskTimedOutEventDetails$ = [3, n0, _TTOED,
    0,
    [_rT, _re, _e, _ca],
    [0, 0, [() => SensitiveError, 0], [() => SensitiveCause, 0]], 2
];
exports.TestStateConfiguration$ = [3, n0, _TSC,
    0,
    [_rRC, _eCBS, _mIFC, _mIRD],
    [1, [() => TestStateStateName, 0], 1, [() => SensitiveData, 0]]
];
exports.TestStateInput$ = [3, n0, _TSI,
    0,
    [_de, _rA, _i, _iL, _rSe, _v, _sN, _mo, _co, _sCt],
    [[() => Definition, 0], 0, [() => SensitiveData, 0], 0, 2, [() => SensitiveData, 0], [() => TestStateStateName, 0], [() => exports.MockInput$, 0], [() => SensitiveData, 0], [() => exports.TestStateConfiguration$, 0]], 1
];
exports.TestStateOutput$ = [3, n0, _TSO,
    0,
    [_o, _e, _ca, _iDns, _nS, _st],
    [[() => SensitiveData, 0], [() => SensitiveError, 0], [() => SensitiveCause, 0], [() => exports.InspectionData$, 0], 0, 0]
];
exports.TracingConfiguration$ = [3, n0, _TCr,
    0,
    [_en],
    [2]
];
exports.UntagResourceInput$ = [3, n0, _URI,
    0,
    [_rAe, _tK],
    [0, 64 | 0], 2
];
exports.UntagResourceOutput$ = [3, n0, _URO,
    0,
    [],
    []
];
exports.UpdateMapRunInput$ = [3, n0, _UMRI,
    0,
    [_mRA, _mC, _tFP, _tFC],
    [0, 1, 1, 1], 1
];
exports.UpdateMapRunOutput$ = [3, n0, _UMRO,
    0,
    [],
    []
];
exports.UpdateStateMachineAliasInput$ = [3, n0, _USMAI,
    0,
    [_sMAA, _d, _rC],
    [0, [() => AliasDescription, 0], () => RoutingConfigurationList], 1
];
exports.UpdateStateMachineAliasOutput$ = [3, n0, _USMAO,
    0,
    [_uD],
    [4], 1
];
exports.UpdateStateMachineInput$ = [3, n0, _USMI,
    0,
    [_sMA, _de, _rA, _lC, _tC, _p, _vD, _eC],
    [0, [() => Definition, 0], 0, () => exports.LoggingConfiguration$, () => exports.TracingConfiguration$, 2, [() => VersionDescription, 0], () => exports.EncryptionConfiguration$], 1
];
exports.UpdateStateMachineOutput$ = [3, n0, _USMO,
    0,
    [_uD, _rI, _sMVA],
    [4, 0, 0], 1
];
exports.ValidateStateMachineDefinitionDiagnostic$ = [3, n0, _VSMDD,
    0,
    [_se, _cod, _m, _lo],
    [0, [() => ValidateStateMachineDefinitionCode, 0], [() => ValidateStateMachineDefinitionMessage, 0], [() => ValidateStateMachineDefinitionLocation, 0]], 3
];
exports.ValidateStateMachineDefinitionInput$ = [3, n0, _VSMDI,
    0,
    [_de, _ty, _se, _mR],
    [[() => Definition, 0], 0, 0, 1], 1
];
exports.ValidateStateMachineDefinitionOutput$ = [3, n0, _VSMDO,
    0,
    [_res, _di, _t],
    [0, [() => ValidateStateMachineDefinitionDiagnosticList, 0], 2], 2
];
var ActivityList = [1, n0, _AL,
    0, () => exports.ActivityListItem$
];
var ExecutionList = [1, n0, _EL,
    0, () => exports.ExecutionListItem$
];
var HistoryEventList = [1, n0, _HEL,
    0, [() => exports.HistoryEvent$,
        0]
];
var LogDestinationList = [1, n0, _LDL,
    0, () => exports.LogDestination$
];
var MapRunList = [1, n0, _MRL,
    0, () => exports.MapRunListItem$
];
var RoutingConfigurationList = [1, n0, _RCL,
    0, () => exports.RoutingConfigurationListItem$
];
var StateMachineAliasList = [1, n0, _SMAL,
    0, () => exports.StateMachineAliasListItem$
];
var StateMachineList = [1, n0, _SML,
    0, () => exports.StateMachineListItem$
];
var StateMachineVersionList = [1, n0, _SMVL,
    0, () => exports.StateMachineVersionListItem$
];
var TagKeyList = 64 | 0;
var TagList = [1, n0, _TL,
    0, () => exports.Tag$
];
var ValidateStateMachineDefinitionDiagnosticList = [1, n0, _VSMDDL,
    0, [() => exports.ValidateStateMachineDefinitionDiagnostic$,
        0]
];
var VariableNameList = [1, n0, _VNL,
    0, [() => VariableName,
        0]
];
var AssignedVariables = [2, n0, _AV,
    0, [() => VariableName,
        0],
    [() => VariableValue,
        0]
];
var VariableReferences = [2, n0, _VR,
    8, [0,
        0],
    [() => VariableNameList,
        0]
];
exports.CreateActivity$ = [9, n0, _CA,
    2, () => exports.CreateActivityInput$, () => exports.CreateActivityOutput$
];
exports.CreateStateMachine$ = [9, n0, _CSM,
    2, () => exports.CreateStateMachineInput$, () => exports.CreateStateMachineOutput$
];
exports.CreateStateMachineAlias$ = [9, n0, _CSMA,
    0, () => exports.CreateStateMachineAliasInput$, () => exports.CreateStateMachineAliasOutput$
];
exports.DeleteActivity$ = [9, n0, _DA,
    0, () => exports.DeleteActivityInput$, () => exports.DeleteActivityOutput$
];
exports.DeleteStateMachine$ = [9, n0, _DSM,
    0, () => exports.DeleteStateMachineInput$, () => exports.DeleteStateMachineOutput$
];
exports.DeleteStateMachineAlias$ = [9, n0, _DSMA,
    0, () => exports.DeleteStateMachineAliasInput$, () => exports.DeleteStateMachineAliasOutput$
];
exports.DeleteStateMachineVersion$ = [9, n0, _DSMV,
    0, () => exports.DeleteStateMachineVersionInput$, () => exports.DeleteStateMachineVersionOutput$
];
exports.DescribeActivity$ = [9, n0, _DAe,
    0, () => exports.DescribeActivityInput$, () => exports.DescribeActivityOutput$
];
exports.DescribeExecution$ = [9, n0, _DE,
    0, () => exports.DescribeExecutionInput$, () => exports.DescribeExecutionOutput$
];
exports.DescribeMapRun$ = [9, n0, _DMR,
    0, () => exports.DescribeMapRunInput$, () => exports.DescribeMapRunOutput$
];
exports.DescribeStateMachine$ = [9, n0, _DSMe,
    0, () => exports.DescribeStateMachineInput$, () => exports.DescribeStateMachineOutput$
];
exports.DescribeStateMachineAlias$ = [9, n0, _DSMAe,
    0, () => exports.DescribeStateMachineAliasInput$, () => exports.DescribeStateMachineAliasOutput$
];
exports.DescribeStateMachineForExecution$ = [9, n0, _DSMFE,
    0, () => exports.DescribeStateMachineForExecutionInput$, () => exports.DescribeStateMachineForExecutionOutput$
];
exports.GetActivityTask$ = [9, n0, _GAT,
    0, () => exports.GetActivityTaskInput$, () => exports.GetActivityTaskOutput$
];
exports.GetExecutionHistory$ = [9, n0, _GEH,
    0, () => exports.GetExecutionHistoryInput$, () => exports.GetExecutionHistoryOutput$
];
exports.ListActivities$ = [9, n0, _LA,
    0, () => exports.ListActivitiesInput$, () => exports.ListActivitiesOutput$
];
exports.ListExecutions$ = [9, n0, _LE,
    0, () => exports.ListExecutionsInput$, () => exports.ListExecutionsOutput$
];
exports.ListMapRuns$ = [9, n0, _LMR,
    0, () => exports.ListMapRunsInput$, () => exports.ListMapRunsOutput$
];
exports.ListStateMachineAliases$ = [9, n0, _LSMA,
    0, () => exports.ListStateMachineAliasesInput$, () => exports.ListStateMachineAliasesOutput$
];
exports.ListStateMachines$ = [9, n0, _LSM,
    0, () => exports.ListStateMachinesInput$, () => exports.ListStateMachinesOutput$
];
exports.ListStateMachineVersions$ = [9, n0, _LSMV,
    0, () => exports.ListStateMachineVersionsInput$, () => exports.ListStateMachineVersionsOutput$
];
exports.ListTagsForResource$ = [9, n0, _LTFR,
    0, () => exports.ListTagsForResourceInput$, () => exports.ListTagsForResourceOutput$
];
exports.PublishStateMachineVersion$ = [9, n0, _PSMV,
    2, () => exports.PublishStateMachineVersionInput$, () => exports.PublishStateMachineVersionOutput$
];
exports.RedriveExecution$ = [9, n0, _RE,
    2, () => exports.RedriveExecutionInput$, () => exports.RedriveExecutionOutput$
];
exports.SendTaskFailure$ = [9, n0, _STF,
    0, () => exports.SendTaskFailureInput$, () => exports.SendTaskFailureOutput$
];
exports.SendTaskHeartbeat$ = [9, n0, _STH,
    0, () => exports.SendTaskHeartbeatInput$, () => exports.SendTaskHeartbeatOutput$
];
exports.SendTaskSuccess$ = [9, n0, _STS,
    0, () => exports.SendTaskSuccessInput$, () => exports.SendTaskSuccessOutput$
];
exports.StartExecution$ = [9, n0, _SEt,
    2, () => exports.StartExecutionInput$, () => exports.StartExecutionOutput$
];
exports.StartSyncExecution$ = [9, n0, _SSE,
    { [_end]: ["sync-"] }, () => exports.StartSyncExecutionInput$, () => exports.StartSyncExecutionOutput$
];
exports.StopExecution$ = [9, n0, _SEto,
    0, () => exports.StopExecutionInput$, () => exports.StopExecutionOutput$
];
exports.TagResource$ = [9, n0, _TR,
    0, () => exports.TagResourceInput$, () => exports.TagResourceOutput$
];
exports.TestState$ = [9, n0, _TS,
    { [_end]: ["sync-"] }, () => exports.TestStateInput$, () => exports.TestStateOutput$
];
exports.UntagResource$ = [9, n0, _UR,
    0, () => exports.UntagResourceInput$, () => exports.UntagResourceOutput$
];
exports.UpdateMapRun$ = [9, n0, _UMR,
    0, () => exports.UpdateMapRunInput$, () => exports.UpdateMapRunOutput$
];
exports.UpdateStateMachine$ = [9, n0, _USM,
    2, () => exports.UpdateStateMachineInput$, () => exports.UpdateStateMachineOutput$
];
exports.UpdateStateMachineAlias$ = [9, n0, _USMA,
    0, () => exports.UpdateStateMachineAliasInput$, () => exports.UpdateStateMachineAliasOutput$
];
exports.ValidateStateMachineDefinition$ = [9, n0, _VSMD,
    0, () => exports.ValidateStateMachineDefinitionInput$, () => exports.ValidateStateMachineDefinitionOutput$
];
